<template>
	<div>
		<OnBoardingSectionHeader
			:isOpen="isOpen"
			:numOfSteps="numOfSteps"
			:sectionDetails="sectionDetails"
			@click.native="$emit('section-clicked')"
			:numOfCompletedSteps="numOfCompletedSteps"
			:remainingNumOfMinutes="remainingNumOfMinutes"
			:totalNumOfMinutesToComplete="totalNumOfMinutesToComplete"
		/>
		<div class="steps-container" :class="{ show: isOpen }">
			<OnBoardingSectionStep
				v-on="$listeners"
				:key="`step-${i}`"
				:stepDetails="step"
				:isOpen="isStepOpen(step)"
				v-for="(step, i) in steps"
				:class="{ 'mt-5': i !== 0 }"
				@step-clicked="() => onStepClick(step)"
				@open-next-step="() => steps[i + 1] && onStepClick(steps[i + 1])"
			/>
		</div>
	</div>
</template>

<script>
import OnBoardingSectionStep from '@/components/Onboarding/OnBoardingFlow/OnBoardingSection/OnBoardingSectionStep.vue';
import OnBoardingSectionHeader from '@/components/Onboarding/OnBoardingFlow/OnBoardingSection/OnBoardingSectionHeader.vue';
export default {
	name: 'OnBoardingSection',
	props: {
		isOpen: { type: Boolean },
		sectionDetails: { type: Object },
	},
	components: {
		OnBoardingSectionStep,
		OnBoardingSectionHeader,
	},
	computed: {
		steps() {
			return this.sectionDetails.steps;
		},
		numOfSteps() {
			return this.steps.length;
		},
		completedSteps() {
			return this.steps.filter((step) => step.isCompleted);
		},
		unCompletedSteps() {
			return this.steps.filter((step) => !step.isCompleted);
		},
		numOfCompletedSteps() {
			return this.completedSteps.length;
		},
		numOfUnCompletedSteps() {
			return this.unCompletedSteps?.length;
		},
		remainingNumOfMinutes() {
			if (this.numOfUnCompletedSteps) {
				return this.unCompletedSteps.map((i) => i.minutesToComplete).reduce((a, b) => a + b);
			} else {
				return 0;
			}
		},
		totalNumOfMinutesToComplete() {
			if (this.steps.length) {
				return this.steps.map((i) => i.minutesToComplete).reduce((a, b) => a + b);
			} else {
				return 0;
			}
		},
	},
	methods: {
		isStepOpen(step) {
			return this.openedStepId === step.id;
		},
		onStepClick(step) {
			if (this.isStepOpen(step)) {
				return (this.openedStepId = null);
			} else {
				return (this.openedStepId = step.id);
			}
		},
	},
	mounted() {
		if (this.isOpen && this.unCompletedSteps?.length) {
			this.openedStepId = this.unCompletedSteps[0].id;
		}
	},
	data() {
		return {
			openedStepId: null,
		};
	},
	watch: {
		isOpen: {
			handler(newV) {
				if (newV && this.unCompletedSteps?.length > 0) {
					this.openedStepId = this.unCompletedSteps[0].id;
				}
			},
			immediate: true,
		},
		numOfUnCompletedSteps(newV) {
			if (newV === 0 && this.isOpen) {
				this.$emit('open-next-section');
			}
		},
	},
};
</script>

<style scoped lang="scss">
$transition-time: 0.3s;
.steps-container {
	width: 100%;
	overflow: hidden;
	background: var(--white);
	transition: $transition-time;
	&:not(.show) {
		height: 0px;
	}
	&.show {
		border-top: 0px;
		border: 1px solid #e4e7ed;
		transition: $transition-time;
		border-radius: 0 0 10px 10px;
		padding: 50px 25px 36px 25px;
	}
}
</style>
